export const removeLastWord = (str: string): string => {
  const lastIndexOfSpace = str.lastIndexOf(' ');

  if (lastIndexOfSpace === -1) {
    return '';
  }

  return str.substring(0, lastIndexOfSpace);
};
